import { OnSchedRest }  from "../OnSchedRest";


export const GetResource = (element, id) => new Promise(resolve => {
  const url = element.onsched.setupApiBaseUrl + '/resources/' + id;

  OnSchedRest.Get(url, resolve)
})